// extracted by mini-css-extract-plugin
module.exports = {"wrapperAboutCourse":"AboutCourse_wrapperAboutCourse__2-WYB"};